import Axios from "@/plugins/Axios";

const BASE_URL = "ponto-instrutores";

export class InstrutorHorariosService {
  async meusHorariosDia(params = {}) {
    const response = await Axios().get(`${BASE_URL}/meus-horarios/dia`, { params });
    return response.data;
  }

  async meusHorariosUltimos10Dias() {
    const response = await Axios().get(`${BASE_URL}/meus-horarios/ultimos-10-dias`);
    return response.data;
  }

  async meusHorariosPeriodo(params = {}) {
    const response = await Axios().get(`${BASE_URL}/meus-horarios/periodo`, { params });
    return response.data;
  }

  async meusHorariosPeriodoPdf(params = {}) {
    const response = await Axios().get(`${BASE_URL}/meus-horarios/periodo/pdf`, {
      params,
      responseType: "arraybuffer",
    });

    return this.criarPdfUrl(response.data);
  }

  async listarInstrutores() {
    const response = await Axios().get(`${BASE_URL}/admin/instrutores-horarios/instrutores`);
    return response.data;
  }

  async adminHorariosDia(params = {}) {
    const response = await Axios().get(`${BASE_URL}/admin/instrutores-horarios/dia`, { params });
    return response.data;
  }

  async adminHorariosUltimos10Dias(params = {}) {
    const response = await Axios().get(`${BASE_URL}/admin/instrutores-horarios/ultimos-10-dias`, {
      params,
    });
    return response.data;
  }

  async adminHorariosPeriodo(params = {}) {
    const response = await Axios().get(`${BASE_URL}/admin/instrutores-horarios/periodo`, {
      params,
    });
    return response.data;
  }

  async adminHorariosPeriodoPdf(params = {}) {
    const response = await Axios().get(`${BASE_URL}/admin/instrutores-horarios/periodo/pdf`, {
      params,
      responseType: "arraybuffer",
    });

    return this.criarPdfUrl(response.data);
  }

  async abrirComprovanteBatida(batidaId) {
    const response = await Axios().get(`${BASE_URL}/instrutor-batidas/${batidaId}/comprovante`, {
      responseType: "arraybuffer",
    });

    const blob = new Blob([response.data], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);
    const novaAba = window.open(url);

    if (!novaAba) {
      const link = document.createElement("a");
      link.href = url;
      link.download = `comprovante_ponto_${batidaId}.pdf`;
      link.click();
    }
  }

  criarPdfUrl(data) {
    const blob = new Blob([data], { type: "application/pdf" });
    return window.URL.createObjectURL(blob);
  }
}

export default new InstrutorHorariosService();
